"use client";

import { useEffect } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useRouter } from "next/navigation";
import { initialiseNativeCompanionPush } from "@/lib/native/companion-push";
import { listenForNativeAppLinks } from "@/lib/native/app-links";

export function NativeAppLifecycle() {
  const router = useRouter();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    void initialiseNativeCompanionPush(path => router.push(path)).catch(() => undefined);
    let launchMemory: Storage | undefined;
    try { launchMemory = window.sessionStorage; } catch { /* Storage can be restricted. */ }
    return listenForNativeAppLinks(App, (url) => {
      if (url === window.location.href) return;
      const target = new URL(url);
      if (target.origin === window.location.origin) {
        router.push(`${target.pathname}${target.search}${target.hash}`);
      } else {
        window.location.assign(url);
      }
    }, launchMemory);
  }, [router]);

  return null;
}
